import { post } from 'aws-amplify/api';
import { PRESCRIPTSURE } from '../constants/api-endpoints';
import { getSessionToken } from './service-config';
const apiNamePath = PRESCRIPTSURE.ANALYTICS_API;

const sessionEngagementActivityAnalyticService = {
  async getPeakUsageDistribution() {
    const sessionToken = await getSessionToken();

    const getPeakUsageDistributionOperation = post({
      apiName: apiNamePath,
      path: '/session_activity',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          query_path: 'today_hourly_sessions',
        },
      },
    });

    const getPeakUsageDistributionResults = (
      await getPeakUsageDistributionOperation.response
    ).body.json();

    return getPeakUsageDistributionResults;
  },

  async getMostActiveUsers() {
    const sessionToken = await getSessionToken();

    const getMostActiveUsersOperation = post({
      apiName: apiNamePath,
      path: '/session_activity',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          query_path: 'top_10_active_users',
        },
      },
    });

    const getMostActiveUsersResults = (
      await getMostActiveUsersOperation.response
    ).body.json();

    return getMostActiveUsersResults;
  },

  async getTotalSessionDetails() {
    const sessionToken = await getSessionToken();

    const getTotalSessionDetailsOperation = post({
      apiName: apiNamePath,
      path: '/session_activity',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          query_path: 'total_sessions',
        },
      },
    });

    const getTotalSessionDetailsResults = (
      await getTotalSessionDetailsOperation.response
    ).body.json();

    return getTotalSessionDetailsResults;
  },

  async getSessionDetails() {
    const sessionToken = await getSessionToken();

    const getSessionDetailsOperation = post({
      apiName: apiNamePath,
      path: '/session_activity',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          query_path: 'session_stats',
        },
      },
    });

    const getSessionDetailsResults = (
      await getSessionDetailsOperation.response
    ).body.json();

    return getSessionDetailsResults;
  },

  async getSessionHeatMapDetails() {
    const sessionToken = await getSessionToken();

    const getSessionHeatMapDetailsOperation = post({
      apiName: apiNamePath,
      path: '/session_activity',
      options: {
        headers: {
          Authorization: `Bearer ${sessionToken}`,
        },
        queryParams: {},
        body: {
          query_path: 'session_heatmap',
        },
      },
    });

    const getSessionHeatMapDetailsResults = (
      await getSessionHeatMapDetailsOperation.response
    ).body.json();

    return getSessionHeatMapDetailsResults;
  },
};

export default sessionEngagementActivityAnalyticService;
